(function() {
    // 목록 템플릿
    var listTemplate = '' +
        '{{#each (item, index) in list}}' +
        '    <li>' +
        '        <a href="https://www.youtube.com/watch?v={{item.id}}" target="_blank" rel="noopener" data-app-link="inAppBrowser" title="새창열림">' +
        '            <div class="thumb">' +
        '                <img src="{{item.thumbnailMedium}}" alt="{{item.title}}">' +
        '            </div>' +
        '            <p class="tit">{{#raw item.title}}</p>' +
        '        </a>' +
        '    </li>' +
        '{{/each}}';

    var lgeYoutube = {
        init: function() {
            var self = this;
            var $paginationContainer = $('div.story-list-wrap .pagination');

            // 1. 라이브러리가 로드되기 전에 클릭되는 것을 막기 위해 우선 비활성화
            $paginationContainer.css('pointer-events', 'none');

            vcui.require(['ui/pagination'], function () {
                self.setting();
                self.bindEvents();

                // 최초 조회
                var urlParams = new URLSearchParams(window.location.search);
                self.requestData(urlParams);

                // 3. 모든 준비가 끝나면 다시 활성화
                $paginationContainer.css('pointer-events', 'auto');
            });
        },

        setting: function() {
            var self = this;
            var $contents = $('div.story-list-wrap');

            // 페이지네이션 컴포넌트 초기화
            self.$pagination = $contents.find('div.pagination').vcPagination();
        },

        bindEvents: function() {
            var self = this;

            // 2. 라이브러리가 제공하는 안정적인 'page_click' 이벤트를 다시 사용
            self.$pagination.on('page_click', function(e, page) {
                var urlParams = new URLSearchParams(window.location.search);
                urlParams.set('page', page);
                self.requestData(urlParams);
            });

            // 컨텐츠 클릭 이벤트
            $('div.story-list ul.quick-view').on('click', 'a', function(e) {
                e.preventDefault();
                var data = $(this).data();
                var $popup = $('#shorts-popup');
                $('.shorts-swiper-wrap .swiper')[0].swiper.slideTo(data.index);
                $popup.find(".video-cap-section").hide();
                $popup.addClass('onload').vcModal('open'); // open
            });

            // 브라우저 뒤로가기/앞으로가기 이벤트 처리
            $(window).on('popstate', function(e) {
                var urlParams = new URLSearchParams(window.location.search);
                self.requestData(urlParams, true); // popstate 이벤트로 인한 호출이므로 skipHistoryUpdate를 true로 전달
            });
        },

        requestData: function(urlParams, skipHistoryUpdate) {
            var self = this;
            var $contents = $('div.story-list-wrap');
            var $itemList = $contents.find('ul.story-list-box');
            var $count = $itemList.siblings('p.count').find('span');

            // URLSearchParams에서 모든 파라미터를 객체로 변환
            var params = {channel : 'LG전자'};
            urlParams.forEach(function(value, key) {
                params[key] = value;
            });

            // popstate 이벤트로 인한 호출이 아닌 경우에만 URL 업데이트
            if (!skipHistoryUpdate) {
                var queryString = urlParams.toString();
                if (queryString != '') {
                    history.pushState(null, '', window.location.pathname + '?' + queryString);
                }
            }

            lgkorUI.requestKongAjax("displaysvc", "/ajax/v1/story/video-list", {
                method: "GET",
                data: params,
                success: function(response) {
                    var data = response.data;

                    // 카운트
                    $count.text(vcui.number.addComma(data.totalCount));

                    // 목록
                    var listData = data && data.list instanceof Array ? data.list : [];
                    if (listData.length > 0) {
                        self.$pagination.show();
                        $itemList.html(vcui.template(listTemplate, {list : listData}));
                        lgkorUI._addImgOnloadEvent(); // no-img 처리
                        $itemList.show();
                    } else {
                        $itemList.hide();
                        self.$pagination.hide();
                    }

                    // 페이징
                    self.$pagination.vcPagination('setPageInfo', {page: data.page, totalCount:data.totalPage});

                    // 포커스
                    $itemList.find('li:first a').focus();
                },
                error: function(xhr, status, error) {
                    $itemList.hide();
                    self.$pagination.hide();
                    void 0;
                }
            }, true, true);
        }

    };

    $(document).ready(function() {
        lgeYoutube.init();
    });

})();